import React from 'react';
import {GoodsItem} from "./GoodsItem";

interface Props {
    items: [];
    siteId:number;
    includeUserLoyaltyProgram: boolean;
}


export class RenderGoods extends React.Component<Props, {}> {

    render() {
        // window.scrollTo( 0, 0 );
        let arData: any = this.props.items;
        let siteId:number = this.props.siteId;
        let includeUserLoyaltyProgram:boolean = this.props.includeUserLoyaltyProgram;

        // @ts-ignore
        return (
            <>
                <div className="goods-wrapper">
                    {arData.length ? arData.map((item: any) => (
                        <GoodsItem key={'item-s'+item.id} item={item} siteId={siteId} includeUserLoyaltyProgram={includeUserLoyaltyProgram} />
                    )) : <div>Нет товаров</div>}
                </div>
            </>
        );
    }
}